
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/[slug]/dashboard",
      function () {
        return require("private-next-pages/events/[slug]/dashboard.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/[slug]/dashboard"])
      });
    }
  